import { defineComponent as t, openBlock as r, createBlock as a, unref as p, mergeProps as d, withCtx as i, createElementVNode as e } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconDisk",
  __name: "IconDisk",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const o = l;
    return (c, n) => (r(), a(p(u), d(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...n[0] || (n[0] = [
        e("path", { d: "M18 11.25A.75.75 0 0 1 18.75 12 6.75 6.75 0 0 1 12 18.75a.75.75 0 0 1 0-1.5A5.25 5.25 0 0 0 17.25 12 .75.75 0 0 1 18 11.25" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M12 9.25a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m0 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M12 5.25a.75.75 0 0 1 0 1.5A5.25 5.25 0 0 0 6.75 12a.75.75 0 0 1-1.5 0A6.75 6.75 0 0 1 12 5.25" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25m0 1.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
